var staticStrFirst = 'first'

module.exports = staticStrFirst



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xe-utils@3.5.7@xe-utils/staticStrFirst.js
// module id = 75
// module chunks = 0 1 2 3 4